import { render, staticRenderFns } from "./ServicesSection.vue?vue&type=template&id=1cd870cf&scoped=true"
import script from "./ServicesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServicesSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ServicesSection.vue?vue&type=style&index=0&id=1cd870cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd870cf",
  null
  
)

export default component.exports